import React from 'react';
import './style.css'; 


const WeSuggest = () => {
 
 
  return (
    <div id="wesuggest" className="service-area section-padding">
      <div className="container">
        <div className="section-title">
          <h2>We Suggest</h2>
          <div className="info-block">
            <div className="icon-w-text">
              <img src="/images/airplane.png" alt="w" 
              />
              <h5>Ταξιδέψτε</h5>
          <p>
          Προτείνουμε το Διεθνές Αεροδρόμιο Λάρνακας (LCA), ωστόσο είναι και το Διεθνές Αεροδρόμιο Πάφου (PFO).
          </p>
          </div>
          <div className="icon-w-text">
          <img src="/images/car.png" alt="w" />
<h5>Κινηθείτε</h5>
          <p>
          Με αμάξι ή taxi. 
          </p>
          <p>Σχετικά με τις διαδρομές λεωφορείων, λειτουργούν κανονικά από πόλη σε πόλη - χωριό σε χωριό, παρόλα αυτά δεν είναι τακτικές και πιθανότατα να μην βολεύουν με βάση την ώρα.</p>
          <p>Για τους καλεσμένους μας προτείνουμε ενοικίαση αυτοκινήτου από την Νατάσα Σταύρου 25-30€/την ημέρα ανάλογα με διαθεσιμότητα. Τηλ. Επικοινωνίας 0035799952029
Παρακαλώ επικοινωνήστε μέσω της εφαρμογής «Viber» ή «What’s up»
</p>
          </div>
          </div>
        </div>
       


      </div>
    </div>
  );
};

export default WeSuggest;